
function Reversible () {}

Reversible.events = {
    isInit: true,

    initialize: function() {
        var isReversible = _.isEqual(ub.config.isReversible, "1");
        var onSide2 = _.isEqual(ub.config.isEmbedded , "1");

        if (isReversible) {
            var that = Reversible.events;
            if (that.isInit) {
                $(".reversible-thumbnail").on("click", 'a.reverse-uniform-button', that.onReverseUniform);
                that.isInit = false;
            }

            if (onSide2) {
                _.delay(function() {
                    var thumbnail = Reversible.funcs.generateThumbnail();
                    var data = {
                        type: "change-thumbnail",
                        thumbnail: thumbnail
                    };

                    Reversible.funcs.sendPostMessagetoParent(data);
                }, 4000);

                parent.document.body.style.overflow = "hidden";
            }
        }
    },

    onReverseUniform: function() {
        var reverse = $(this).data("reverse");
        var side = ub.config.side;
        var onSide2 = _.isEqual(ub.config.isEmbedded , "1");
        var thumbnail = Reversible.funcs.generateThumbnail();

        Reversible.funcs.onChangeTeamColors();

        if (onSide2) {
            var data = {
                type: "change-side",
                side: side,
                reverse: reverse,
                thumbnail: thumbnail
            };

            Reversible.funcs.sendPostMessagetoParent(data);
        } else {
            var data = {
                type: "change-thumbnail",
                thumbnail: thumbnail
            };

            Reversible.funcs.sendPostMessage(data);
            Reversible.funcs.changeSide(side, reverse);
        }

    }
}

Reversible.funcs = {
    changeSide: function(side, reverse, image) {
        $(".main-panel[data-side='"+ side +"']").addClass("hidden");
        $(".main-panel[data-side='"+ reverse +"']").removeClass("hidden");

        if (typeof image !== "undefined") {
            Reversible.funcs.changeThumbnailImage(image);
        }

        parent.document.body.style.overflow = "auto";
    },

    changeThumbnailImage: function(image) {
        $(".reversible-thumbnail .reverse-uniform-button").removeClass("hidden");
        $(".reversible-thumbnail .thumbnail-loading").addClass("hidden");

        $(".reversible-thumbnail img").prop("src", "");
        $(".reversible-thumbnail img").prop("src", image);

        SaveDesign.events.showSide1SaveButton();

        if (typeof ub.config.pageType !== "undefined") {
            if (ub.config.pageType === "Order Editor") {
                window.parent.$("#right-pane-column .update-order-design").removeClass("uk-hidden");
                $("#right-pane-column .update-order-design").removeClass("uk-hidden");
            }
        }
    },

    sendPostMessage: function(data) {
        var iframe = document.querySelector("#embedded-panel-container iframe");
        var reverseWindow = iframe.contentWindow;
        reverseWindow.onbeforeunload = null;
        reverseWindow.postMessage(data, ub.config.host);
    },

    sendPostMessagetoParent: function(data) {
        window.parent.postMessage(data, ub.config.host);
    },

    onSaveDesignSide2: function(savedOnly) {
        var data = {
            type: "save-side-2"
        };

        if (savedOnly) {
            data.savedOnly = savedOnly;
        }

        Reversible.funcs.sendPostMessage(data);
    },

    onSaveDesignSide1: function(savedOnly) {
        var data = {
            type: "save-side-1" 
        };

        if (savedOnly) {
            data.savedOnly = savedOnly;
        }

        Reversible.funcs.sendPostMessagetoParent(data);
    },

    onUpdateSide2: function() {
        var data = {
            type: "update-side-2"
        };
        
        Reversible.funcs.sendPostMessage(data);
    },

    onUpdateSide1: function() {
        var data = {
            type: "update-side-1" 
        };

        Reversible.funcs.sendPostMessagetoParent(data);
    },

    onOrderPreviewSide2: function() {
        var data = {
            type: "order-save-preview-side-2"
        };

        Reversible.funcs.sendPostMessage(data);
    },

    onOrderPreviewSide1: function() {
        var data = {
            type: "order-save-preview-side-1"
        };

        Reversible.funcs.sendPostMessagetoParent(data);
    },

    saveTheOtherSide: function(bc) {
        var data = {
            type: "save-the-other-side",
            bc: bc
        };

        var onSide2 = _.isEqual(ub.config.isEmbedded , "1");

        if (onSide2) {
            Reversible.funcs.sendPostMessagetoParent(data);
        } else {
            Reversible.funcs.sendPostMessage(data);
        }
    },

    updateTheOtherSide: function(bc) {
        var data = {
            type: "update-the-other-side",
            bc: bc
        };

        var onSide2 = _.isEqual(ub.config.isEmbedded , "1");

        if (onSide2) {
            Reversible.funcs.sendPostMessagetoParent(data);
        } else {
            Reversible.funcs.sendPostMessage(data);
        }
    },

    generateThumbnail: function() {
        ub.front_view.visible = true;
        ub.funcs.deactivateMoveTool();
        ub.funcs.removeLocations();

        return ub.getThumbnailImage("front_view");
    },

    onChangeTeamColors: function() {
        let isReversible = ub.config.isReversible === "1";
        let onSide2 = ub.config.isEmbedded === "1";
        let data = {
            type: "update-team-colors",
            teamColors: ub.funcs.getTeamColors()
        };

        if(isReversible) {
            if(onSide2) {
                Reversible.funcs.sendPostMessagetoParent(data);
            } else {
                Reversible.funcs.sendPostMessage(data);
            }
        }
    },

    hidePart: function (sport, part, side) {
        let items = [
            {
                sport: "Basketball (Quickturn)",
                parts: ["locket_tag"], // code case
                side: "Side 2"
            }
        ];

        let isReversible = ub.config.isReversible === "1";
        if (isReversible) {
            let item = _.find(items, {sport: sport, side: side});

            if (typeof item !== "undefined") {
                return item.parts;
            }
        }

        return undefined;
    },

    // manually update `builder_customizations` on reversible saved design
    // link missing side
    linkOtherSide: function(id) {
        var reversible = ub.current_material.settings.reversible;
        if (typeof reversible !== 'undefined') {
            var side = reversible.side;
            var savedDesignId = ub.config.savedDesignInfo.savedDesignID;
            var prepareData = SaveDesign.funcs.reversibleData(savedDesignId, side, id);
                prepareData.name = ub.savedDesignName;
                prepareData.notes = ub.savedDesignNotes;

            SaveDesign.Api.updateDesign(prepareData, (res) => {
                console.log("Result: ", res);
            });
        }
    },

    // hide button on builder if single ply reversible design is loaded
    hideSaveAndContinueBtn: function() {
        let INVALID_REVERSIBLE = !ProlookReversible.funcs.isValidReversible();
        if (INVALID_REVERSIBLE) { 
                console.info("⚙️ Missing Side B. Hiding the Save and Continue button!");
                $("#save-and-continue").hide();
        }
    },

    // show notif on builder if single ply reversible design is loaded
    showNotifOnSaveAndContinueBtn: function() {
        let INVALID_REVERSIBLE = !ProlookReversible.funcs.isValidReversible();
        if (INVALID_REVERSIBLE) { 
            UIkit.notification({
                message: "Missing Side B. Please load a valid reversible design to proceed!",
                status: 'danger',
                pos: 'top-right'
            });
        }
    },

    // check if the loaded reversible in builder is valid
    isValidReversible: function() {
        let valid = true; 

        if (ub.config.blockPattern.indexOf('Ply Reversible') > -1) {
            valid = ub.config.blockPattern.indexOf('Ply Reversible') > -1 && ub.config.isReversible === "1";
        }

        return valid;
    }
}